export const FormControlList = {
    InputBox: 'InputBox',
    Number: 'Number',
    Decimal: 'Decimal',
    DropDownList: 'DropDownList',
    MultipleDropDownList: 'MultipleDropDownList',
    TreeSelect: 'TreeSelect',
    CheckBox: 'CheckBox',
    FileUpload: 'FileUpload',
    Picture: 'Picture',
    RadioButton: 'RadioButton',
    DatePicker: 'DatePicker',
    DateTimePicker: 'DateTimePicker',
    Rating: 'Rating',
    ToggleButton: 'ToggleButton',
    Percentage: "Percentage",
    Currency: "Currency",
    Date: "Date",
    AutoNumber: "AutoNumber",
    Lookup: "Lookup",
    UserLookup: "UserLookup",
    Time: "Time",
    Formula: "Formula",
    EncryptedText: "EncryptedText",
    RichText: "RichText",
    Barcode: "Barcode",
    MultiLine: "Multi-Line",
    Email: "Email",
    Phone: "Phone",
    URL: "URL",
    IPAddress: 'IPAddress'
}

export enum FormControlListIds {
    DropDownList = 1,
    CheckBox = 2,
    RadioButton = 3,
    ToggleButton = 4,
    Picture = 5,
    FileUpload = 6,
    Rating = 7,
    InputBox = 8,
    DatePicker = 9,
    MultipleDropDownList = 11,
    Number = 19,
    Decimal = 20,
    Percentage = 21,
    Currency = 22,
    MultiLine = 36,
    Email = 37,
    Phone = 38,
    URL = 39,
    DateTimePicker = 40,
    AutoNumber = 41,
    Lookup = 42,
    Time = 44,
    Formula = 45,
    EncryptedText = 46,
    RichText = 47,
    Barcode = 48,
    IPAddress = 49,
    UserLookup = 50,
}

// Function to get name from value
export function getFormControlNameById(id: number): string | undefined {
    const FormControlListIdsReverse = {} as any;

    Object.keys(FormControlListIds)
        .filter((key) => !isNaN(Number(FormControlListIds[key])))
        .map((key) => {
            FormControlListIdsReverse[FormControlListIds[key]] = key;
        });

    return FormControlListIdsReverse[id]||'InputBox';
}

export const CommaSeparatedControls = [FormControlList.MultipleDropDownList,FormControlList.CheckBox];
export const ActivityCommaSeparatedControls = [FormControlList.MultipleDropDownList,FormControlList.CheckBox];
export const CSVControls = [FormControlList.MultipleDropDownList,FormControlList.CheckBox];
